import { type AccessControlConfig } from 'legacy/components/AccessControl/accessControl.utils'
import useAccessControl from 'legacy/components/AccessControl/useAccessControl'
import { useDeepMemo } from 'utils/react/react.hooks'

export const useHasAccess = (accessControlConfig: AccessControlConfig) => {
  const hasAccess = useAccessControl()
  return useDeepMemo(() => hasAccess(accessControlConfig), [hasAccess, accessControlConfig])
}
